<form [formGroup]="baseFormGroup" #f="ngForm" class="mt-4 pl-2">
  <div class="form-horizontal">
    <div class="row">
      <div class="col-md-12">
        <div class="form-group row">
          <div class="col-md-12">
            <yt-dropdown-picklist
              [ModelName]="'komitent'"
              [GetName]="'get'"
              [ModelProperty]="'SNaziv,Mesto'"
              [OrderBy]="'SNaziv'"
              [AllowAddNew]="false"
              [AllowEdit]="false"
              formControlName="KomitentID"
              [Label]="'KOMITENTOBJEKATUPISNOMESTO.KOMITENT.SINGULAR'"
              [Width]="'150%'"
              [Position]="'left'"              
              (OnItemSelected)="onKomitentSelect($event)"
              #cmbKomitent
              #autofocus              
            >
            </yt-dropdown-picklist>
            
          </div>
        </div>

        <div class="form-group row">
          <div class="col-md-12">
            <yt-dropdown-picklist
              [ModelName]="'komitentobjekat'"
              [GetName]="'GetByKomitentID'"
              [GetParameters]='parameterList'   
              [ModelProperty]="'NazivObjekta'"
              [OrderBy]="'NazivObjekta'"
              [AllowAddNew]="true"
              [AllowEdit]="true"
              formControlName="KomitentObjekatID"
              [Label]="'KOMITENTOBJEKATUPISNOMESTO.KOMITENTOBJEKAT.SINGULAR'"
              [Width]="'150%'"
              [Position]="'left'"             
              #cmbKomitentObjekat
            >
            </yt-dropdown-picklist>
            <div class="form-error" *ngIf="submitted && fc.KomitentObjekatID.invalid">
              <span *ngFor="let validation of errorMessages.KomitentObjekatID">
                <span
                  class="error-message"
                  *ngIf="fc.KomitentObjekatID.hasError(validation.type)"
                  ><span translate="{{ validation.message }}"></span
                ></span>
              </span>
            </div>
          </div>
        </div>

        <div class="form-group row">
          <div class="col-md-12">
            <yt-input
              [Type]="'text'"
              name="txtNazivUpisnogMesta"
              formControlName="NazivUpisnogMesta"
              #txtNaziv
              [MaxLength]="100"
              [ngClass]="{ 'is-invalid': submitted && fc.NazivUpisnogMesta.invalid }"
              [Label]="'KOMITENTOBJEKATUPISNOMESTO.NAZIVUPISNOGMESTA.SINGULAR'"
              #autofocus
            >
            </yt-input>
            <div
              class="form-error"
              *ngIf="submitted && fc.NazivUpisnogMesta.invalid"
            >
              <span *ngFor="let validation of errorMessages.NazivUpisnogMesta">
                <span
                  class="error-message"
                  *ngIf="fc.NazivUpisnogMesta.hasError(validation.type)"
                  ><span translate="{{ validation.message }}"></span
                ></span>
              </span>
            </div>
          </div>
        </div>
        
       
 
      </div>
    </div>
  </div>
</form>
